module.exports = __webpack_public_path__ + "img/CrossCorrelation1.c322010d.png";